import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Loader2, ExternalLink } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { isInIframe } from '../lib/supabaseClient';
import { toast } from 'sonner';

export default function LoginPage() {
  const { signInWithGoogle } = useAuth();
  const [loading, setLoading] = useState(false);
  const inIframe = isInIframe();

  const handleGoogleSignIn = async () => {
    try {
      setLoading(true);
      await signInWithGoogle();
    } catch (err) {
      const msg = err.message || 'Failed to sign in';
      console.error('[Login] Auth error:', msg, err);
      toast.error(msg, { duration: 8000 });
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: 'radial-gradient(80% 60% at 20% 0%, hsl(204 90% 92%) 0%, transparent 60%), hsl(210 20% 98%)' }}>
      <Card className="w-full max-w-md shadow-[var(--shadow-2)]" data-testid="login-card">
        <CardHeader className="text-left pb-2">
          <CardTitle className="text-xl" data-testid="login-title" data-role="heading">
            Authorized Access Only
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          {inIframe && (
            <p className="text-xs text-muted-foreground text-center">
              A popup window will open for secure sign-in.
            </p>
          )}
          <Button
            onClick={handleGoogleSignIn}
            disabled={loading}
            className="w-full h-11 text-base font-medium transition-colors duration-150 active:scale-[0.98]"
            data-testid="login-google-button"
          >
            {loading ? (
              <Loader2 className="mr-2 h-5 w-5 animate-spin" />
            ) : inIframe ? (
              <ExternalLink className="mr-2 h-5 w-5" />
            ) : (
              <svg className="mr-2 h-5 w-5" viewBox="0 0 24 24">
                <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" />
                <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
              </svg>
            )}
            {loading ? 'Signing in...' : inIframe ? 'Sign in to CMG Ops' : 'Sign in with Google'}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
